@if (chats().length === 0) {
<div class="chats-list__empty re-empty-state re-empty-state--compact">
  <div class="chats-list__empty-icon re-empty-state__icon" aria-hidden="true">
    <ion-icon name="chatbubbles-outline"></ion-icon>
  </div>
  <p class="chats-list__empty-title re-empty-state__title">{{ 'stories.home.roomsEmpty' | translate }}</p>
  <p class="chats-list__empty-hint re-empty-state__description">{{ 'stories.home.roomsEmptyHint' | translate }}</p>
</div>
} @else {
<div class="chats-list" [class.chats-list--compact]="compact()">
  <ion-list lines="none" class="re-card-list chats-list__list">
    @for (chat of chats(); track chat.id; let i = $index) {
    <ion-item button [detail]="true" detailIcon="chevron-forward-outline" [routerLink]="[chat.id]"
      routerLinkActive="chats-list__item--active" [routerLinkActiveOptions]="{ exact: true }">
      <span slot="start" class="re-list-row-avatar" [class.re-list-row-avatar--amber]="i % 2 === 1" aria-hidden="true">
        <ion-icon [name]="chatIcon(chat)"></ion-icon>
      </span>
      <ion-label>
        <h2 class="re-list-row-title">
          @if (chatTitleKey(chat); as titleKey) {
          {{ titleKey | translate }}
          } @else {
          {{ chat.name }}
          }
        </h2>
        <p class="re-list-row-note">
          @if (chat.kind === 'lore' || chat.kind === 'story') {
          {{ chatSubtitle(chat) | translate }}
          } @else if (chat.users.length) {
          {{ chatSubtitle(chat) | translate: chatSubtitleParams(chat) }}
          }
        </p>
      </ion-label>
    </ion-item>
    }
  </ion-list>
</div>
}
